export default __webpack_public_path__ + "media/images/react_icons/linkedin-with-frame-7fd77eeeec1fd17ddaafc29b817a9aaa.svg";